import React from "react";
import { ShoppingCart, ArrowLeft, Package } from "lucide-react";

const Header = ({
  restaurant,
  onCartClick,
  cartItems,
  onCheckOrderStatus,
  onBackClick,
}) => {
  return (
    <header className="bg-white shadow-md sticky top-0 z-50 backdrop-blur-sm bg-opacity-95">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Left Section - Back Button & Restaurant Info */}
          <div className="flex items-center gap-3 md:gap-4 flex-1 min-w-0">
            <button
              onClick={onBackClick}
              className="flex-shrink-0 p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-full transition-all duration-200 hover:scale-105 active:scale-95"
              aria-label="Back to Home"
            >
              <ArrowLeft className="w-5 h-5 md:w-6 md:h-6" />
            </button>

            <div className="flex items-center gap-3 min-w-0">
              <div className="relative flex-shrink-0">
                <img
                  src={restaurant?.logo}
                  alt={restaurant?.name}
                  className="w-11 h-11 md:w-14 md:h-14 rounded-full object-cover border-2 border-gray-100 shadow-sm"
                />
                <div className="absolute -bottom-0.5 -right-0.5 w-3.5 h-3.5 bg-green-500 border-2 border-white rounded-full"></div>
              </div>

              <div className="flex flex-col min-w-0">
                <h1 className="font-bold text-gray-900 text-base md:text-xl truncate">
                  {restaurant?.name}
                </h1>
                {restaurant?.description && (
                  <p className="text-xs md:text-sm text-gray-500 truncate">
                    {restaurant?.description}
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* Right Section - Action Buttons */}
          <div className="flex items-center gap-2 md:gap-3 ml-4">
            <button
              onClick={onCheckOrderStatus}
              className="hidden sm:flex items-center gap-2 px-4 py-2.5 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold rounded-lg shadow-sm hover:shadow-md transition-all duration-200 text-sm hover:scale-105 active:scale-95"
            >
              <Package className="w-4 h-4" />
              <span className="hidden lg:inline">Orders</span>
              <span className="lg:hidden">Orders</span>
            </button>

            {/* Mobile Order Status Button */}
            <button
              onClick={onCheckOrderStatus}
              className="sm:hidden flex items-center justify-center p-2.5 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white rounded-lg shadow-sm hover:shadow-md transition-all duration-200 active:scale-95"
              aria-label="Check Order Status"
            >
              <Package className="w-5 h-5" />
            </button>

            <button
              onClick={onCartClick}
              className="relative p-2.5 md:p-3 text-gray-700 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-all duration-200 hover:scale-105 active:scale-95"
              aria-label="View Cart"
            >
              <ShoppingCart className="w-5 h-5 md:w-6 md:h-6" />
              {cartItems > 0 && (
                <span className="absolute -top-1 -right-1 bg-gradient-to-br from-red-500 to-red-600 text-white text-xs rounded-full h-5 w-5 md:h-6 md:w-6 flex items-center justify-center font-bold shadow-lg animate-pulse">
                  {cartItems > 99 ? "99+" : cartItems}
                </span>
              )}
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
